import { ActionIcon, Text } from "@mantine/core";
import { IconPaperclip } from "@tabler/icons-react";
import { useMemo } from "react";

import { useDispatch } from "../../../redux/hooks";
import { setBodyPartPreviewModalData } from "../../../redux/slices/generatorFeaturesSlice";
import { Flex, StyledActionIcon } from "../../../styled";
import { type BodyPart } from "./BodyPart.model";
import { BodyPartItem } from "./BodyPart.styled";
import BodyPartModalClear from "./BodyPartModalClear";

interface Props {
  label?: string;
  bodyParts: BodyPart[];
  setBodyParts?: (bodyParts: BodyPart[]) => void;
  inputId?: string;
  type: "front" | "back";
  direction?: "row" | "column";
  clearable?: boolean;
  viewable?: boolean;
}
const BodyPartList = ({
  label,
  bodyParts,
  type,
  direction,
  clearable,
  setBodyParts,
  viewable,
  inputId,
}: Props) => {
  const dispatch = useDispatch();
  const parts = useMemo(
    () =>
      new Array(
        ...new Set(
          bodyParts.filter(el => el.type === type).map(el => el.selectedPart),
        ),
      ),
    [bodyParts, type],
  );

  const handleView = (partName: string) => {
    dispatch(
      setBodyPartPreviewModalData({
        value: bodyParts,
        selectedName: partName,
        selectedType: type,
        inputId,
      }),
    );
  };
  if (parts.length === 0) return null;
  return (
    <div>
      {label && <Text size="sm">{`${label}${!viewable ? ": " : ""}`}</Text>}
      <Flex gap={5} wrap="wrap" direction={direction ?? "row"}>
        {clearable && setBodyParts && (
          <BodyPartModalClear
            selectedParts={bodyParts}
            setSelectedParts={setBodyParts}
            type={type}
          />
        )}
        {parts.map(
          part =>
            part && (
              <BodyPartItem key={`${type}-${part}`}>
                <Text fz={13}>{`${!viewable ? "- " : ""}${part}`}</Text>
                {viewable && (
                  <StyledActionIcon onClick={() => handleView(part)}>
                    <IconPaperclip size="1.3rem" />
                  </StyledActionIcon>
                )}
              </BodyPartItem>
            ),
        )}
      </Flex>
    </div>
  );
};
export default BodyPartList;
